module.exports = __webpack_public_path__ + "img/about-1.a201b2f9.png";